import React from "react";
import {Plan} from "./components/Plan";
import {styleTheme} from "../../../../style/theme";
import styled from "styled-components";
import {getPrimaryColor} from "../../../../style/utils";
import {BridalPlanProps} from "../../BridalPlans.types";

type Props = {
  plans: BridalPlanProps[] | undefined
  bridalFairPageKey: string
  primaryColor: string
}

type ComponentProps = Props & {
  className?: string
}

export const Plans: React.FC<Props> = (props) => (
  <StyledComponent {...props} />
)

const Component: React.FC<ComponentProps> = ({
  plans,
  bridalFairPageKey,
  primaryColor,
  className,
}) => {
  return (
    <div className={className}>
      {plans?.map((plan) => (
        <Plan
          plan={plan}
          key={plan.id}
          bridalFairPageKey={bridalFairPageKey}
          primaryColor={primaryColor}
        />
      ))}
    </div>
  )
}

export const StyledComponent = styled(Component)`
  @media (max-width: 520px) {
    flex-direction: column;
  }

  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;

  > h4, pre {
    margin: 0;
  }

  > pre {
    font-size: 14px;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  > .event-info-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 4px;

    > .event-tag {
      background-color: ${styleTheme.colors.gray.light};
      padding: 4px 12px;
      border-radius: 4px;
    }
  }

  > .event-info-items {
    line-height: 1.5;
    display: flex;
    flex-wrap: wrap-reverse;
    gap: 16px 24px;

    > .event-info-minutes {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    > .event-special-offers {
      display: flex;
      gap: 4px;

      > span {
        color: ${getPrimaryColor};
        font-size: 12px;
        border: 1px solid ${getPrimaryColor};
        padding: 2px 8px;
        border-radius: 2px;
      }
    }
  }

  > .event-info-times {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;

    > span {
      display: flex;
    }
  }
`;
